import { useEffect } from "react";

export function useStructuredData(id: string, data: Record<string, unknown> | null) {
  useEffect(() => {
    if (!data) return;

    const script = document.createElement("script");
    script.id = `structured-data-${id}`;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);

    // Remove any existing script with same id
    const existing = document.getElementById(script.id);
    if (existing) existing.remove();

    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(`structured-data-${id}`);
      if (el) el.remove();
    };
  }, [id, data]);
}

export function useBreadcrumbStructuredData(
  items: { name: string; url: string }[]
) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
  useStructuredData("breadcrumb", data);
}
